module.exports = "/build/admin/images/authy-kleur.5ee4c078.png";